import React, { Component } from 'react';
import './App.css';

class App extends React.Component {
  constructor(){
    super();
    this.state={
      users : []
    }
  }

  render() {
      return (
      <div>
      <h1 className="App">Weezon user listing!</h1>
        <div>{this.state.users}</div>
      </div>
      );
  }

  componentDidMount(){
    fetch("https://weezon.herokuapp.com/users")
    .then(results=>{
      return results.json();
    }).then(data=>{
      let users = data.map(user=>{
        return (
          <div key={user._id}>
            {user.name}<br/>
            {user.phoneNum}
          </div>
        )
      })
      this.setState({users:users});
    });
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js